import React, { useEffect } from 'react';

const InfoModal = ({ isOpen, onClose, title, children, closeOnlyByButton = false }) => {
    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        // Сохраняем позицию: иначе position:fixed у body (см. .modal-open) сбрасывает страницу в начало
        const scrollY = window.scrollY;
        document.body.classList.add('modal-open');
        document.body.style.top = `-${scrollY}px`;

        return () => {
            document.body.classList.remove('modal-open');
            document.body.style.top = '';
            window.scrollTo(0, scrollY);
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleOverlayClick = () => {
        if (!closeOnlyByButton) {
            onClose && onClose();
        }
    };

    const handleCloseClick = () => {
        if (!closeOnlyByButton) {
            onClose && onClose();
        }
    };

    return (
        <div className="info-modal-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true">
            <div className="info-modal" onClick={(e) => e.stopPropagation()}>
                {!closeOnlyByButton && (
                    <button className="info-modal-close" onClick={handleCloseClick} aria-label="Закрыть">×</button>
                )}
                {title && <h2 className="info-modal-title">{title}</h2>}
                <div className="info-modal-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default InfoModal;


